import '../../modules/mode-components';

import * as angular from 'angular';

import ContextModalController from './context-modal-controller';
import template from './context-modal.html';
import { AccountFacade } from '@mode/accounts/contract';

const contextModalDirective = function (Modal, accountFacade: AccountFacade, $window) {
  return {
    restrict: 'A',
    scope: {
      account: '<',
      homeName: '@',
      currentContext: '@',
      connectDatabaseElementId: '<',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click.context', (event) => {
        if (!attrs.evented) {
          event.preventDefault();
          event.stopPropagation();
        }

        accountFacade.loadUserOrgs();

        const modal = Modal.open(
          {
            homeName: $scope.homeName,
            account: $scope.account,
            context: attrs.currentContext,
            connectDatabaseElementId: $scope.connectDatabaseElementId,
          },
          {
            template: template,
            controller: ContextModalController,
            controllerAs: 'ctrl',
            bindToController: true,
          }
        );
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.context'));
    },
  };
};

contextModalDirective.$inject = ['ModalService', 'AccountFacade', '$window'];

angular.module('mode.components').directive('contextModal', contextModalDirective);
